import { Navbar } from './Navbar';
import { Sidebar } from './Sidebar';
import { ChatWindow } from './ChatWindow';

export function Layout() {
  return (
    <div className="h-screen flex flex-col bg-base">
      <Navbar />
      <div className="flex-1 flex overflow-hidden">
        <Sidebar />
        <main className="flex-1 flex flex-col overflow-hidden">
          <ChatWindow />
        </main>
      </div>
    </div>
  );
}
